import { render, staticRenderFns } from "./Desktop.vue?vue&type=template&id=1c4c8378&"
import script from "./Desktop.vue?vue&type=script&lang=js&"
export * from "./Desktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DealerDesktop: require('/usr/src/motec/components/dealer/Desktop.vue').default,BackToTopButton: require('/usr/src/motec/components/BackToTopButton.vue').default})
